<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            PolicyButtons(:item="item", @refresh="$emit('refresh')")
        .column.shrink
          .field P{{item.id}}
          .field {{item.name}}
        //.column.shrink
          .field Type
          .field {{item.type}}
        .column.shrink(v-for="(conf,key) in item.configuration")
          .bookable(v-if="key ==='max_bookable' || key ==='min_bookable'")
            div {{key.replace('_',' ')}}
            div {{conf}}
          .booking_days(v-if="key === 'booking_days'")
            div Booking Days
            span(v-for="c in conf") {{c}}&nbsp;
    .inner-content(v-if="$is('entity-policy')")
      .row
        .column
          .field P{{item.id}}
          .field {{item.name}}
        .column
          .field Type
          .field {{item.type}}
        .column(v-for="(conf,key, i) in item.configuration")
          div {{key}}
          div(v-if="typeof conf === 'number'") {{conf}}

</template>

<script>
  import CardN from '../structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import PolicyButtons from '../structure/ui/actions/PolicyButtons'

  export default {
    name: 'Policy',
    components: {PolicyButtons, Dropdown, CardN},
    props: ['item', 'type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Policy.vue?971cfbfe